import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HeartBrokenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"heart_broken"}/>
}
